/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OutputAllRolesDto } from '../../models/output-all-roles-dto';

export interface UserManagementGetAllRolesGet$Plain$Params {
}

export function userManagementGetAllRolesGet$Plain(http: HttpClient, rootUrl: string, params?: UserManagementGetAllRolesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OutputAllRolesDto>>> {
  const rb = new RequestBuilder(rootUrl, userManagementGetAllRolesGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OutputAllRolesDto>>;
    })
  );
}

userManagementGetAllRolesGet$Plain.PATH = '/UserManagement/GetAllRoles';
